import { faker } from '@faker-js/faker'
import dayjs from 'dayjs'
import { http, HttpResponse } from 'msw'

import { GetCustomerCardsResponse } from '@/api/agency/customers/get-customer-cards'

export const mockGetCustomerCards = http.get(
  '/my-business/api/agency/v1/customers/:customerId/cards',
  () => {
    const data: GetCustomerCardsResponse = {
      data: Array.from({ length: 5 }).map(() => ({
        active: faker.datatype.boolean(),
        shared: faker.datatype.boolean(),
        brandCode: faker.helpers.arrayElement(['VISA', 'MASTER_CARD']),
        companyAlphaId: faker.string.uuid(),
        companyName: faker.company.name(),
        id: faker.number.int(5),
        description: faker.lorem.sentence(),
        holder: faker.person.fullName(),
        creditCardName: faker.lorem.words(3),
        truncatedNumber: faker.string
          .numeric(6)
          .concat('******')
          .concat(faker.string.numeric(4)),
        companyType: faker.helpers.arrayElement([
          'AGENCY_CHAIN',
          'AGENCY',
          'SALES_POINT',
        ]),
        expireDate: dayjs(faker.date.future()).format('MM/YY'),
      })),
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
